import { c as _c } from "react/compiler-runtime";
import type { Project } from 'content-collections';
import { LightbulbIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { Badge } from '@/components/ui/badge';
import { ContentCard } from './content-card';
type ProjectCardProps = {
  project: Project;
  featured?: boolean;
  lazy?: boolean;
  showTechstack?: boolean;
};
export function ProjectCard(props) {
  const $ = _c(23);
  const {
    project,
    featured: t0,
    lazy: t1,
    showTechstack: t2
  } = props;
  const featured = t0 === undefined ? false : t0;
  const lazy = t1 === undefined ? true : t1;
  const showTechstack = t2 === undefined ? false : t2;
  const t = useTranslations();
  const t3 = project.slug;
  const t4 = `/projects/${project.slug}`;
  let t5;
  if ($[0] !== t) {
    t5 = t("homepage.selected-projects.card");
    $[0] = t;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const t6 = `/images/projects/${project.slug}/cover.png`;
  let t7;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <LightbulbIcon className="size-4.5" />;
    $[2] = t7;
  } else {
    t7 = $[2];
  }
  let t8;
  if ($[3] !== project.title) {
    t8 = <h3 className="text-2xl font-semibold">{project.title}</h3>;
    $[3] = project.title;
    $[4] = t8;
  } else {
    t8 = $[4];
  }
  let t9;
  if ($[5] !== project.description) {
    t9 = <p className="mt-2 text-muted-foreground">{project.description}</p>;
    $[5] = project.description;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] !== project.techstack || $[8] !== showTechstack) {
    t10 = showTechstack && <div className="mt-3 flex flex-wrap gap-1.5">{project.techstack.map(_temp)}</div>;
    $[7] = project.techstack;
    $[8] = showTechstack;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t10 || $[11] !== t8 || $[12] !== t9) {
    t11 = <div className="flex flex-col px-2 py-4 transition-transform ease-out group-hover:translate-x-0.5">{t8}{t9}{t10}</div>;
    $[10] = t10;
    $[11] = t8;
    $[12] = t9;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== featured || $[15] !== lazy || $[16] !== project.description || $[17] !== project.slug || $[18] !== t11 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t12 = <ContentCard key={t3} href={t4} title={t5} image={t6} imageAlt={project.description} icon={t7} featured={featured} lazy={lazy}>{t11}</ContentCard>;
    $[14] = featured;
    $[15] = lazy;
    $[16] = project.description;
    $[17] = project.slug;
    $[18] = t11;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  return t12;
}
function _temp(tech) {
  return <Badge key={tech} variant="outline">{tech}</Badge>;
}